import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectionPickupBg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 20,
	viewBox: "0 0 44 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 20,
			rx: 10,
			fill: "#E2E6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 10.5C19.4766 10.9219 19.1484 11.25 18.75 11.25H17.9766V15.75C17.9766 16.1719 17.6484 16.5 17.2266 16.5H15C14.5781 16.5 14.25 16.1719 14.25 15.75V13.125C14.25 12.9375 14.0625 12.75 13.875 12.75H11.625C11.4141 12.75 11.25 12.9375 11.25 13.125V15.75C11.25 16.1719 10.8984 16.5 10.5 16.5H8.25C7.82812 16.5 7.5 16.1719 7.5 15.75V11.25H6.75C6.32812 11.25 6 10.9219 6 10.5C6 10.2891 6.07031 10.1016 6.23438 9.9375L12.2344 4.6875C12.3984 4.54688 12.5859 4.5 12.75 4.5C12.9141 4.5 13.1016 4.57031 13.2422 4.6875L19.2422 9.9375C19.4062 10.1016 19.5 10.2891 19.5 10.5Z",
			fill: "#3D5AFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.17 13.35L37.61 13.36L35.15 10.9L30.25 6L28.52 7.75L31.67 10.9H23V13.36H34.99V13.35H35.17Z",
			fill: "#3D5AFE"
		})
	]
});
const ForwardRef = forwardRef(SvgDirectionPickupBg);
export { ForwardRef as ReactComponent };
